import template from './tasksHeader.html';
import controller from './tasksHeaderCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    onGeneratePdf: '&',
  },
};
